module.exports = "//static.hsappstatic.net/pricing-pages-ui-components/static-1.15868/js/hsocImages/credits_explainer_sparkle.svg"